import { MultipleSelect } from "@components/Select/MultipleSelect";

interface NotifyDropdownProps {
  options: { label: string }[];
  option: string[];
  setOption: (value: string[]) => void;
  error?: boolean;
}

const NotifyDropdown = ({ options, option, setOption, error }: NotifyDropdownProps) => {
  return <MultipleSelect options={options} option={option} setOption={setOption} error={error} />;
};

export default NotifyDropdown;
